import { render } from "./Measurement.vue?vue&type=template&id=2953f34c&scoped=true"
import script from "./Measurement.vue?vue&type=script&lang=js"
export * from "./Measurement.vue?vue&type=script&lang=js"

import "./Measurement.vue?vue&type=style&index=0&id=2953f34c&scoped=true&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2953f34c"]])

export default __exports__